(function(){
    'use strict'; 
    angular.module('Directives').directive('imgViewer', imgViewer);
    imgViewer.$inject = []; 

    function imgViewer() {
        return {
            restrict: 'E', 
            template: `
                <img ng-src="{{img}}">
            `,
            scope: {
                imgUrl: '=?'
            },
            link: imgViewerLink
        }

        function imgViewerLink($scope, $elems, $attrs) {
            init();

            function init() {
                console.log($scope.imgUrl);
                $scope.img = $scope.imgUrl || '/images/custom_icons/no_image.png';
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/shipment-details/imgViewer.js